


import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  createMuiTheme,
  Grid,Backdrop,CircularProgress,
  Card,CardContent,Divider
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import axios from 'src/utils/axios';
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import Purchase from 'src/components/Purchase';
import trLocale from 'date-fns/locale/tr';
import { getUser } from 'src/utils/Common';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
    searchButton: {
        borderColor: 'green',
        color: 'green',
        '&:hover': {
            backgroundColor: 'green',
            color: 'white',
        },
        height: '56px',
    },
    fullHeight: {
        height: '100%',
    },
    pageStyleAtanan: {
        display: 'flex',
        padding: '5px',
        alignItems:'center',
        marginBottom:'10px'
    },
    backdropMI: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const siyah = '#424242';
const materialTheme = createMuiTheme({
    palette: {
      primary: {
        contrastText: '#FFFFFF',
        dark: siyah,
        main: siyah,
        light: siyah
      },
    },
  });
const localeMap = {
    tr: trLocale,
  };

const ValueProposition = () => {
  const { t } = useTranslation('overview');
  const [products, setProducts] = useState([]);
  const [selectedWorkCase, setSelectedWorkCase] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [StartDate, setStartDate] = useState(moment().subtract(1, 'days').format('YYYY-MM-DD'));
  const locale = localStorage.getItem('i18nextLng');
  const classes = useStyles();
  const [loading,setLoading] = useState(false);

  const [EndDate, setEndDate] =  useState(moment(new Date()).format('YYYY-MM-DD'));

  const SessionUser = getUser();

  const fetchProductsByConsumerId = async () => {
    setLoading(true);
    axios
      .get(`/GetConsumerValuePropositionsTechnician/${SessionUser.TechnicianId}/${StartDate}/${EndDate}/${SessionUser.ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0 && response.data !== "") {
          setProducts(response.data);
        } 
        setLoading(false);
      })
  };

  const handleProductClick = (product) => {
    setSelectedWorkCase(product.WorkCaseId);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedWorkCase(null);
  };

  const handleMenuItemClick = (option, selectedProduct) => {
    setMenuAnchorEl(null);
    if (option === 'Purchase') {
      handleProductClick(selectedProduct);
    }
  };

  const StartDatehandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    setStartDate(Deger);
  };

  const EndDatehandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    setEndDate(Deger);
  };

  return (
    <div>
      <style jsx>{`
        .product-page-container {
          padding: 20px;
          background-color: #f0f0f0; /* Grey background */
        }

        .warranty-section {
        }

        .contracts-container {
          display: flex;
          justify-content: space-between;
        }

        .contracts-section {
          width: 48%;
          border: 1px solid #ccc;
          padding: 10px;
          border-radius: 4px;
          background-color: white; /* Ensure white background for content */
        }

        .section-title {
          margin-bottom: 20px;
        }
      `}</style>

      <div className="product-page-container">
        <div>
            <Typography
                component="h1"
                gutterBottom
                variant="h3"
                >
                {t('Merhaba')}
                ,
                {' '}
                {SessionUser.FirstName}
                {' '}
                {SessionUser.LastName}
            </Typography>
            <Typography 
                component="h1"
                gutterBottom
                variant="h4"
                style={{margin:'10px'}}
            >
                {t('lblValueProposation')}
            </Typography>
        </div>
        <Paper component="form" className={classes.pageStyleAtanan}>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} md={5} className={classes.fullHeight}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                                <KeyboardDatePicker
                                    fullWidth
                                    margin="normal"
                                    color="primary"
                                    inputVariant="outlined"
                                    id="BaslangiçTarihi"
                                    label={t('BaslangicTarihi')}
                                    invalidDateMessage={t('hatali_tarih')}
                                    format="dd.MM.yyyy"
                                    variant="outlined"
                                    value={StartDate}
                                    onChange={(e) => StartDatehandleChange(e)}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </ThemeProvider>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={5} className={classes.fullHeight}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                                <KeyboardDatePicker
                                    fullWidth
                                    margin="normal"
                                    color="primary"
                                    inputVariant="outlined"
                                    id="BitisTarihi"
                                    label={t('BitisTarihi')}
                                    invalidDateMessage={t('hatali_tarih')}
                                    format="dd.MM.yyyy"
                                    variant="outlined"
                                    value={EndDate}
                                    onChange={(e) => EndDatehandleChange(e)}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </ThemeProvider>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={2} className={classes.fullHeight}>
                    <Button
                        variant="outlined"
                        className={classes.searchButton}
                        onClick={() => fetchProductsByConsumerId()}
                        fullWidth
                    >
                        <SearchIcon />
                        {t('lblSearch')}
                    </Button>
                </Grid>
            </Grid>
        </Paper>
        <div className="warranty-section">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('lblAction')}</TableCell>
                  <TableCell>{t('lblProduct')}</TableCell>
                  <TableCell>{t('lblSerialNr')}</TableCell>
                  <TableCell>{t('lblCountofSale')}</TableCell>
                  <TableCell>{t('lblWarrantyStartDate')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                { loading
                    ? (
                      <Backdrop className={classes.backdropMI} open={loading}>
                        <CircularProgress color="inherit" />
                      </Backdrop>
                    )
                    : products.length > 0 ? products.map((product) => (
                  <TableRow key={product.SerialNr}>
                    <TableCell>
                    <IconButton onClick={() => handleMenuItemClick('Purchase',product)}>
                        <ListItemIcon>
                            <ShoppingCartIcon fontSize="small" />
                        </ListItemIcon>
                    </IconButton>
                    </TableCell>
                    <TableCell>{product.Product}</TableCell>
                    <TableCell>{product.SerialNr}</TableCell>
                    <TableCell>{product.CountofSale}</TableCell>
                    <TableCell>{product.WarrantyStartDate}</TableCell>
                  </TableRow>
                )): (
                  <div>
                    <Typography variant="h5" gutterBottom style={{textAlign:'center'}}>
                        <br />
                        {t('NoData')}...
                        <br />
                    </Typography>
                </div>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      {selectedWorkCase && (
        <Dialog
          fullScreen
          open={dialogOpen}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* <span>{t('lblValueProposition')}</span> */}
              <IconButton
                color="primary"
                onClick={handleCloseDialog}
                aria-label="close"
                style={{ position: 'absolute', right: 0 }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent>
            <Purchase WorkCaseId={selectedWorkCase} handleCloseDialog={handleCloseDialog}/>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default ValueProposition;
